import { UserRound, Monitor } from "lucide-react";
import { since } from "@/lib/api";

const Bar = ({ active, label, tone, compact }) => (
  <div className={compact ? "w-10" : "w-24"} title={compact ? label : undefined}>
    {!compact && <p className="text-[11px] text-slate-600 truncate h-4" title={label}>{label}</p>}
    <div className={`h-[3px] rounded-full ${active ? tone : "bg-slate-300"}`} />
  </div>
);

// ScreenConnect-like connection indicator: host (technician) bar + guest (machine) bar
export const ConnBars = ({ m, compact }) => {
  const online = m?.online;
  const host = m?.in_session;
  const ic = compact ? "h-4 w-4" : "h-6 w-6";
  return (
    <div className={`flex ${compact ? "items-center gap-1.5" : "items-end gap-2"} flex-shrink-0`} data-testid={`conn-bars-${m?.machine_id}`}>
      <UserRound className={`${ic} ${host ? "text-green-600" : "text-slate-400"}`} />
      <Bar compact={compact} active={host} label={host ? `Hôte - ${m.technicians.join(", ")}` : ""} tone="bg-green-500" />
      <Bar compact={compact} active={online} label={online ? `Invité - ${since(m.connected_at)}` : ""} tone="bg-green-500" />
      <Monitor className={`${ic} ${online ? "text-green-600" : "text-slate-400"}`} />
    </div>
  );
};
